import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_INTERACTION } from '.';

const OBJECT_INTERACTION = 'about-the-business';

const ABOUT_BUSINESS_CLICKED = 'ecaja-about-the-business-clicked';
export const getAboutBusinessClicked = (
  characterCount: number,
): TealiumEventData => ({
  linkName: ABOUT_BUSINESS_CLICKED,
  eventName: [EVENT_NAME_INTERACTION, ABOUT_BUSINESS_CLICKED],
  objectInteraction: OBJECT_INTERACTION,
  cajaAboutBusinessCharacterCount: characterCount,
});
